<template>
  <div>
    <lab-header ref="alb_header" page-name="Prof. Li"></lab-header>
    <cramb-header page-name="Prof. Li" :path="path"></cramb-header>
    <div class="center" style="text-align: left">
      <div class="Prof clear">
        <div class="msg">
          <div class="Img">
            <img alt="Prof. Li" :src="prof.imgReqUrl">
          </div>
          <div class="info">
            <p class="p" style="margin-top:0.0000pt;margin-bottom:0.0000pt;">
              <b><span style="font-size:24px;">{{prof.engName}}</span></b><b><span style="font-size:24px;">（{{prof.name}}）</span></b>
            </p>
            <p class="MsoNormal">
              <b><span style="font-size:24px;"> <br>
                 </span></b>
            </p>
            <span style="font-size:16px;">{{prof.phd}}</span>
            <p class="p" style="margin-top:0.0000pt;margin-bottom:0.0000pt;">
              <span style="font-size:16px;margin-bottom: 5px">{{prof.dep}}</span><br>
              <span style="font-size:16px;margin-bottom: 5px">{{prof.org}}</span><br>
              <span style="font-size:16px;margin-bottom: 5px">{{prof.researchDirection}}<br></span>
              <span style="font-size:16px;margin-bottom: 5px">{{prof.address}}<br></span>
            </p>
            <p class="p" style="margin-top:0.0000pt;margin-bottom:0.0000pt;">
              <span style="font-size:16px;margin-bottom: 5px">E-mail: {{prof.email}}</span>
              <span style="font-size:16px;margin-bottom: 5px">Homepage: <a :href="prof.homepageUrl" target="_blank">{{prof.homepage}}</a></span>
            </p>
          </div>
        </div>
        <ul class="profList">
          <li v-for="(item, index) in profInfoList" :key="index">
            <i class="title">{{item.name}}</i>
            <div class="info">
              <div class="p" style="margin-bottom: 10px;" v-for="(info, index) in item.infoList" :key="index">
                <div style="display: inline-block;vertical-align: top;"><b>{{info.mark}}</b></div>
                <div style="display: inline-block; width: 90%;vertical-align: top;">{{info.info}}</div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <lab-footer></lab-footer>
  </div>
</template>

<script>
import LabHeader from '../components/public/LabHeader'
import LabFooter from '../components/public/LabFooter'
import CrambHeader from '../components/public/CrambHeader'
export default {
  name: 'ProfessorLi',
  components: { CrambHeader, LabFooter, LabHeader },
  data () {
    return {
      prof: {},
      profInfoList: [
        {
          name: 'EDUCATION',
          infoList: []
        },
        {
          name: 'SOCIAL WORK',
          infoList: []
        },
        {
          name: 'SUBJECTS',
          infoList: []
        },
        {
          name: 'ARTICLES',
          infoList: []
        },
        {
          name: 'PATENTS',
          infoList: []
        }
      ],
      path: [
        {
          name: 'Home',
          url: '/'
        },
        {
          name: 'Prof. Li',
          url: '/prof_li'
        }
      ]
    }
  },
  methods: {
    getBasicInfo () {
      this.$axios.get('/server_api/core/professor/basic_info')
        .then((response) => {
          let res = response.data
          if (res.code === 0) {
            this.prof = res.data
            this.prof.imgReqUrl = this.$getImgPath(this.prof.imgUrl)
          } else {
            this.$message({
              message: '获取轮播图失败',
              type: 'error'
            })
          }
        })
    },
    getProfessorInfo () {
      this.$axios.get('/server_api/core/professor/professor_info')
        .then((response) => {
          let res = response.data
          if (res.code === 0) {
            let professorInfo = res.data.rows
            for (var i = 0; i < res.data.total; i++) {
              if (professorInfo[i].type === 'EDUCATION') {
                this.profInfoList[0].infoList.push(professorInfo[i])
              } else if (professorInfo[i].type === 'SOCIAL WORK') {
                this.profInfoList[1].infoList.push(professorInfo[i])
              } else if (professorInfo[i].type === 'SUBJECTS') {
                this.profInfoList[2].infoList.push(professorInfo[i])
              } else if (professorInfo[i].type === 'ARTICLES') {
                this.profInfoList[3].infoList.push(professorInfo[i])
              } else if (professorInfo[i].type === 'PATENTS') {
                this.profInfoList[4].infoList.push(professorInfo[i])
              }
            }
          } else {
            this.$message({
              message: '获取详细信息失败',
              type: 'error'
            })
          }
        })
    }
  },
  mounted () {
    this.getBasicInfo()
    this.getProfessorInfo()
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/ProfessorLi.vue